module.exports = __webpack_public_path__ + "static/img/no-create@2x.a5ca7933.png";